@if (component.primary.hero_image_desktop) {
  <div class="main-hero-bg" [ngStyle]="{ 'background-image': 'url('+component.primary.hero_image_desktop.url+')' }">
    <div class="mask flex-center rgba-black-light"></div>
  </div>
}
